import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { cardInnerSx } from '../hero/styles';

const cellSx = {
  flex: '1 1 0',
  minHeight: 0,
  minWidth: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  containerType: 'size',
};

/**
 * The few-cards case every entity grid shares: up to three cards spread across
 * the full width rather than left-packed at grid size, so a short page doesn't
 * look like a full one that failed to load.
 *
 * Can be used for either a row or a column of cards, with the `direction` prop.
 */
export default function CardRow({ items, direction, renderCard }) {
  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: direction,
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: 2,
      overflow: 'visible',
    }}>
      {items.map((entity) => (
        <Box key={entity.id} sx={cellSx}>
          <Box sx={cardInnerSx}>
            {renderCard(entity)}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

CardRow.propTypes = {
  items: PropTypes.array.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  renderCard: PropTypes.func.isRequired,
};

CardRow.defaultProps = {
  direction: 'row',
};
